import { createContext, useLayoutEffect, useState, useEffect,useRef } from 'react';
import { axiosInstance } from '../apis/axios';
import moment from 'moment';
import api from '../apis';
import {
    gcmDecrypt,
    generateBearerTokenKey
} from '../crypto/msgCrypto';
import { getUserDetail,useLocalStorageListener,setLogout } from '../hooks/handleUserLocalStorage';


import { useNavigate, useLocation } from 'react-router-dom';
import { useLoading } from './LoadingContext';
import { Modal } from 'antd';

import { showNotiLoaderError } from '../components/general/antd-loader';

import { WarningTwoTone } from '@ant-design/icons';

import { broadcastMessage, listenMessage } from '../components/broadcast';

import Config from '../config';
// let expiredTimer: any = null;

const AxiosContext = createContext({});
let expiredTimeout = null
let unauthorizedCount = 0;  
const MAX_UNAUTHORIZED_ATTEMPTS = 3;  

//handle expired dialog
const WithAxios = ({ children }: any) => {
    let location = useLocation();
    const query = new URLSearchParams(location.search);
    const mode = query.get('mode');
    const navigate = useNavigate();

    const { setLoading, setNotiExpired,setNotiExpiredMsg } = useLoading();
   

    const [forceLogoutModalOpen,setForceLogoutModalOpen] = useState(false);
    const [forceLogoutModalMessage,setForceLogoutModalMessage] = useState('');
    //const [mode, setMode] = useState(null);

    useLayoutEffect(() => {
        //setMode(mode);
        listenMessage((message) => {
            if (message.type === 'forceLogout') {
                console.log("forceLogout");
            }
            if (message.type === 'stayLoggedIn') {
                console.log("stay loginned");

                setTimeoutModal(false);
                setExpiredTimer(null); //stop count down
                
            }
          });
    }, []);

    //timer modal. timeout warning modal
  
    const [timeoutModal, setTimeoutModal] = useState(false);
    const timeoutModalRef = useRef(timeoutModal);
    //expired timeout
    const [expiredTimer, setExpiredTimer] = useState(null);
    //expired date
    const [expiredDate, setExpiredDate] = useState<string | null>(null);

    useEffect(() => {
        window.addEventListener('storage', (event) => {
            window.localStorage.setItem('sessionListner', '');

            let newValue = event.newValue;

           // console.log(event.key, newValue);

            switch (newValue) {
                case 'refresh':
                    console.log("withaxios refresh ")
                    setTimeoutModal(false);
                    api.heartbeat();
        
                    break;
                case 'logout':
                    setTimeoutModal(false);
                    resetUserCookie();
                    break;
            }

            setExpiredTimer(null);
        });

   
        return () => {
            // bc.close();
        };
    }, []);

    useEffect(() => {
        timeoutModalRef.current = timeoutModal;
      }, [timeoutModal]);

    // useEffect(() => {
    //     document.addEventListener('visibilitychange', function () {
    //         if (document.hidden) {
    //             // console.log('not active');
    //             // tab is now inactive
    //             // temporarily clear timer using clearInterval() / clearTimeout()
    //         } else {
    //             // tab is active again
    //             // restart timers
    //             // console.log('active');
    //         }
    //     });
    // }, []);

    //axios response
    useEffect(() => {
        axiosInstance.interceptors.response.use(
            async (response: any) => {
                if(!response) return null;
                
                if (response.status === 200 && response.data) {

                    let headers = response?.headers;
                    let expiredAt = headers['expired-at'];
          
                    if (expiredAt && mode != 'mobile') {
                        //ignore when timeout modal is open
                      
                        if (timeoutModalRef.current === false) {
                        //  console.log('next expired-at', expiredAt);
                            //set current expiredDate
                            setExpiredDate(expiredAt);

                        }
                  
                    }

                    // Reset counter (successful request)
                    if (unauthorizedCount > 0) {
                        // console.log('Request successful, resetting unauthorized counter');
                        unauthorizedCount = 0;
                    }
                    

                    return response; //fetch data to display
                }
                return response;
            },
            async (error: any) => {     
                console.log(error);
            
                // console.log(error.response.status)
                if (
                    error.response.status === 401
                    ||
                    error.response.status === 402
                    ||
                    error.response.status === 404
                    // ||
                    // error.response.status === 0
                    // ||
                    // error.response.status === 502
                ) {

                    try {


                        let isSuccess = false;
                        let pResult = null;  
                        let userDetail = getUserDetail();
                      

                        if (userDetail && userDetail.token) {
                 
                            let data = error.response.data;
                            let token = userDetail.token;
                            let key = await generateBearerTokenKey(token);
                            let result = await gcmDecrypt(data, key);
                         
                            if(result){
                                isSuccess= true; // handle message

                                pResult = JSON.parse(result);

                                //handle session expired or unauthorized
                                if(pResult && pResult.message === "Unauthorized"){
                                    // Increment counter
                                    unauthorizedCount++;
                                    console.log(`Received Unauthorized error, current count: ${unauthorizedCount}/${MAX_UNAUTHORIZED_ATTEMPTS}`);

                                    // Check if threshold reached
                                    if (unauthorizedCount >= MAX_UNAUTHORIZED_ATTEMPTS) {
                                            // console.log('Maximum Unauthorized error attempts reached, forcing logout');

                                        // Reset counter
                                        unauthorizedCount = 0;

                                        // Execute logout
                                        resetUserCookie();
                                        setNotiExpired(true);
                                    } else {
                                        // console.log(`Threshold not reached, postponing logout (${unauthorizedCount}/${MAX_UNAUTHORIZED_ATTEMPTS})`);
                                    }
                                } else if(pResult.message && pResult.message !="Unauthorized"){
                                
                                
                      

                                    // Reset counter (received valid response)
                                    if (unauthorizedCount > 0) {
                                        // console.log('Received valid response, resetting unauthorized counter');
                                        unauthorizedCount = 0;
                                    }

                                    let data = pResult.data;
                                    if(data){
                                        //display force logout by another device
                                        if(data.kicked){
                                            setForceLogoutModalOpen(true); 
                                            setForceLogoutModalMessage(pResult.message);
                                        }
                                  
                                    }else{
                                        setNotiExpiredMsg(pResult.message);
                                        resetUserCookie();
                                        setNotiExpired(true);
                                    }

                   
                                }
                            }

    
                          //  console.log("handle123 key",key)
                           // console.log("handle123 gcmDecrypt",result)
                        }

                        if(!isSuccess){
                            resetUserCookie();
                            setNotiExpired(true);
                        }
    
                    } catch (error) {
                        
                    }
                    
                   

                } else if (error.response.status === 500) {
                    showNotiLoaderError();
                }

            
            }
        );
    }, [axiosInstance]);

    //refresh poout countdown
    useEffect(() => {
      // console.log("expiredDate",expiredDate)
        //setTimeoutModal(false);
        setExpiredTimer(null);
       expiredTimeout = null;

        let userDetail = getUserDetail();
        if (expiredDate && userDetail.user) {
     
            // console.log('set expired date,start timer');
            let expiredMoment = moment(expiredDate); // auto-parse ISO 8601 with timezone offset
            let duration = moment.duration(expiredMoment.diff(moment()));

            let timerAlertCountdown = Config.timerAlertCountdown || 0;
            let triggerCountdownAt =
                duration.asMilliseconds() - timerAlertCountdown * 1000;
        //    console.log('ori expiredDate', expiredDate);
        //          console.log('expiredMoment', expiredMoment);
        //    console.log('set expiredAt', expiredDate);
        //     console.log('duration', duration.asMilliseconds());
        //     console.log('count down at ', triggerCountdownAt);

            //if overtime trigger timer immediately
            if (triggerCountdownAt < 0) {
                triggerCountdownAt = 1000;
                // console.log('dected timeout');
            }


                expiredTimeout = setTimeout(function () {
                    // console.log(
                    //     'start timer',
                    //     moment(expiredDate).format('YYYY-MM-DD HH:mm:ss')
                    // )

                    let isLiveQuotes = location.pathname =="/"?true:false

                    setExpiredTimer(null);

                    //dont trigger when timeout modal popout
                    if(!timeoutModalRef.current){
                        let hasFocus = document.hasFocus();
                        let call_ack = api.getSessAck(isLiveQuotes,hasFocus).then((result) => {
                            let newExpiredAt = result.headers['expired-at'];

                        //console.log('newExpiredAt', newExpiredAt);
                            setExpiredTimer(timerAlertCountdown);
                            if (expiredDate == newExpiredAt && !timeoutModalRef.current) {
                             //   console.log('open modal');
                                setTimeoutModal(true);
                            }
                        });
                    }

                }, triggerCountdownAt);
        }
        return () => {
            clearTimeout(expiredTimeout);
        };
    }, [expiredDate]);

    //render countdown seconds
    useEffect(() => {
       // console.log("trigger withaxios timer ",expiredTimer)
        let TimerInterval = null;
        // console.log(expiredTimer); //countdown seconds

        if (expiredTimer) {
            TimerInterval =
                expiredTimer > 0 &&
                setInterval(() => {
                    setExpiredTimer((time) => time - 1);
                }, 1000);
        } else if (expiredTimer == 0 && expiredTimer != null) {
            // console.log(expiredTimer);
            if (expiredTimer == 0) {
                // console.log(
                //     'timeout, trigger logout',
                //     moment().format('YYYY-MM-DD HH:mm:ss')
                // );
                // console.log('expiredTimer', expiredTimer);
                handleLogout();
                setNotiExpired(true);
                //alert('trigger logout');
            }
        }

        return () => {
            clearInterval(TimerInterval);
        };
    }, [expiredTimer]);

    const handleSessAckHeartbeat = async () => {
       // console.log("handleSessAckHeartbeat");
        await api.heartbeat();

        setTimeoutModal(false);
        setExpiredTimer(null); //stop count down

       // console.log('refresh');
        window.localStorage.setItem('sessionListner', 'refresh');

        broadcastMessage('stayLoggedIn');

    };

    const handleLogout = async () => {
        await setLoading(true);
        let result = await api.userLogout();
        if (result == true) {
            resetUserCookie();
        }
        setLoading(false);
        setExpiredTimer(null);
        window.localStorage.setItem('sessionListner', 'logout');
        broadcastMessage('forceLogout');

       navigate('/');
    };

    const resetUserCookie = async () => {
      //  removeCookie('user', { path: '/' });
        setLogout();
        navigate('/');
        setTimeoutModal(false);
        setExpiredTimer(null);
    };

    // return children;

    return (
        <AxiosContext.Provider value={{ setTimeoutModal }}>
            {/* timeout warning modal */}
            {timeoutModal == true && (
                <Modal
                    title={
                        <div className="d-flex">
                            <WarningTwoTone
                                twoToneColor="#ed0d0d"
                                style={{
                                    fontSize: '16px',
                                    paddingTop: '2px'
                                }}
                            />
                            <div>Timeout Warning</div>
                        </div>
                    }
                    maskClosable={false}
                    keyboard={false}
                    closable={false}
                    open={timeoutModal}
                    okText="Stay logged on"
                    onOk={handleSessAckHeartbeat}
                    cancelText="Log off"
                    onCancel={handleLogout}
                >
                    <p>
                        You will automatically be logged off in {expiredTimer}{' '}
                        seconds
                    </p>
                </Modal>
            )}

            {children}

            <ForceLogoutModal 
                isModalOpen={forceLogoutModalOpen} 
                message={forceLogoutModalMessage}
            />
        </AxiosContext.Provider>
    );
};

//force logout by another device
const ForceLogoutModal = ({ isModalOpen,message }) => {

    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [countdown, setCountdown] = useState(3);

    useEffect(() => {
        if (isModalOpen) {
            setOpen(true);
            let timer = setInterval(() => {
                setCountdown((prev) => {
                    if (prev === 1) {
                        clearInterval(timer);
                        handleLogout(); // Logout user after countdown
                    }
                    return prev - 1;
                });
            }, 1000);

            return () => clearInterval(timer);
        }
    }, [isModalOpen]);

    const handleLogout = ()=>{
        setLogout();
        navigate('/');
        setOpen(false)
    }

    return (
        <Modal
            title=""
            maskClosable={false}
            open={open}
            // okText="Redirect To Login"
            // onOk={handleLogout}
            okButtonProps={{ style: { display: 'none' } }}
            cancelText="Close"
            footer={null}
            // onCancel={handleLogout}
        >
            <div className="row">
                <div className="col-12">
                    <div className="d-flex gap-2">
                        <WarningTwoTone twoToneColor="#ed0d0d" style={{ fontSize: '16px', paddingTop: '2px' }} />
                        <div style={{ paddingRight: '1rem' }}>
                            {message}
                        </div>
                    </div>
                    <div style={{ marginTop: '10px', fontWeight: 'bold', color: 'red' }}>
                        You will be logged out from current session in {countdown} second(s).
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default WithAxios;
